import {useIsFeatureActive} from '@aboutyou/feature-flags';
import React from 'react';
import {InitializeAbTestsConditionally as InitializeAbTestsConditionallyBase} from './InitializeAbTestsConditionally.eager';

export const InitializeAbTestsConditionally = () => {
  const isEnabled = useIsFeatureActive('ab_test_setup_enabled').isActive;
  if (!isEnabled) {
    return null;
  }

  return <InitializeAbTestsConditionallyBase />;
};
